module.exports = __webpack_public_path__ + "static/gallery_16-thumb-5af967179ce4ab224b04b2584d027799.jpg";